/**
 * Data for people involved in LG, what team they belong to, preferred names,
 * and headshot files.
 */

/**
 * Image imports. This is the only way to do this in webpack. I autogen-ed
 * these imports, but manually commented out the ones that have null filenames,
 * i.e. don't have headshots yet.
 */
import scarpent from "../../assets/img/people/Sebastian Carpenter.jpg";
import wjiao from "../../assets/img/people/Weiyin Jiao.jpg";
import szhai from "../../assets/img/people/Sabrina Zhai.jpg";
import jsaik from "../../assets/img/people/Jaclyn Saik.jpg";
import jeeyoonk from "../../assets/img/people/Jeeyoon Kim.jpg";
import sophiaki from "../../assets/img/people/Sophia Kim.jpg";
import rickyche from "../../assets/img/people/Ricky Chen.jpg";
import myou from "../../assets/img/people/Michael You.jpg";
import rxun from "../../assets/img/people/Ruiran Xun.jpg";
import hpnguyen from "../../assets/img/people/Henry Nguyen.jpg";
import changjuc from "../../assets/img/people/Chang Jun Cho.jpg";
// import flg from '../../assets/img/people/null';
import hycai from "../../assets/img/people/Hannah Cai.jpg";
import sammiek from "../../assets/img/people/Sammie Kim.jpg";
import yrt from "../../assets/img/people/Yoshua Torralva.jpg";
// import eileenl1 from '../../assets/img/people/null';
import elizabew from "../../assets/img/people/Elizabeth Wang.jpg";
import ahl2 from "../../assets/img/people/Angela Lee.jpg";
// import alcai from '../../assets/img/people/null';
// import ehyang from '../../assets/img/people/null';
import ertsai from "../../assets/img/people/Elysha Tsai.jpg";
import chsong from "../../assets/img/people/Caroline Song.jpg";
import puxins from "../../assets/img/people/Clytze Sun.jpg";
import ddomalik from "../../assets/img/people/David Domalik.jpg";
import mcagan from '../../assets/img/people/Melissa Cagan.jpg';
import cmay1 from "../../assets/img/people/Christopher May.jpg";
// import iyip from '../../assets/img/people/null';
import vderienz from "../../assets/img/people/Vincent DeRienzo.jpg";
// import aburbano from '../../assets/img/people/null';
import seyoungc from '../../assets/img/people/Seyoung Choo.jpg';
import mpandura from "../../assets/img/people/Maya Pandurangan.jpg";
import abhartia from "../../assets/img/people/Aadya Bhartia.jpg";
import odh from "../../assets/img/people/Owen Haft.jpg";
import carmeny from "../../assets/img/people/Carmen Yu.jpg";
import abandi from "../../assets/img/people/Arushi Bandi.jpg";
import knandgao from "../../assets/img/people/Khushi Nandgaonkar.jpg";
import kathyz from "../../assets/img/people/Kathy Zhang.jpg";
import skylarm  from '../../assets/img/people/Skylar McAuliffe.jpg';
import ajafrani from "../../assets/img/people/Amal Jafrani.jpg";
import jlai2 from "../../assets/img/people/Jessica Lai.jpg";
import ejchapma from "../../assets/img/people/Elise Chapman.jpg";
import nwaldram from "../../assets/img/people/Natalie Waldram.jpg";
import ihorgan from "../../assets/img/people/Isabel Horgan.jpg";
import apao from "../../assets/img/people/Annalisa Pao.jpg";
import yinjiet from "../../assets/img/people/Jacky Tian.jpg";
import minghaoy from "../../assets/img/people/Minghao Yang.jpg";
import lkendric from "../../assets/img/people/Leah Kendrick.jpg";
// import hsiaotyp from '../../assets/img/people/null';
// import jwesthei from '../../assets/img/people/null';
import oluk from "../../assets/img/people/Olivia Luk.jpg";
import cscheire from '../../assets/img/people/Cassandra Scheirer.jpg';
// import madelind from '../../assets/img/people/null';
import adriennw from "../../assets/img/people/Adrienne Wang.jpg";
import aestuart from "../../assets/img/people/Audry Stuart.jpg";
import csinagra from "../../assets/img/people/Chloe Sinagra.jpg";
import christi5 from "../../assets/img/people/Christina Li.jpg";
import cmedward from "../../assets/img/people/Clayton Edwards.jpg";
import dgardilc from "../../assets/img/people/Danova Gardilcic.jpg";
import dongwonl from "../../assets/img/people/Dong Won Lee.jpg";
import fpd from '../../assets/img/people/Fiona Dubrosa.jpg';
import xhe2 from "../../assets/img/people/Xiao He.jpg";
import jlangan from "../../assets/img/people/Jade Langan.jpg";
import jtimczyk from "../../assets/img/people/Jessica Timczyk.jpg";
import minjael2 from "../../assets/img/people/Min Jae Lee.jpg";
import kbalenza from "../../assets/img/people/Kyra Balenzano.jpg";
import lgunasek from "../../assets/img/people/Lahiru Gunasekara.jpg";
import mcornwal from "../../assets/img/people/Melinda Cornwall.jpg";
import laltus from "../../assets/img/people/Lucy Altus.jpg";
import mgamerma from "../../assets/img/people/Max Gamerman.jpg";
import maxliu from "../../assets/img/people/Max Liu.jpg";
import ruomingx from "../../assets/img/people/Ruoming Xin.jpg";
// import makim from '../../assets/img/people/null';
import morganbo from '../../assets/img/people/Morgan Boyd.jpg';
import njeans from "../../assets/img/people/Nathalie Jeans.jpg";
import nathanwa from "../../assets/img/people/Nathan Wai.jpg";
import nwai from "../../assets/img/people/Nora Wai.jpg";
import ojinsi from "../../assets/img/people/Omisa Jinsi.jpg";
// import pgao1 from '../../assets/img/people/null';
import pqin from "../../assets/img/people/Pauline Qin.jpg";
// import rkoanda from '../../assets/img/people/null';
import radeoti from '../../assets/img/people/Remi Adeoti.jpg';
// import sammiep from '../../assets/img/people/null';
// import sophiale from '../../assets/img/people/null';
import tbournia from "../../assets/img/people/Themistokles Bournias.jpg";
import thk1 from "../../assets/img/people/Tiffany Kim.jpg";
import mkimkim from "../../assets/img/people/Min Ji Kim Kim.jpg";
import lannal from "../../assets/img/people/Lanna Lang.jpg";
import sspektor from "../../assets/img/people/Sabina Spektor.jpg";
import ejc2 from "../../assets/img/people/Elizabeth Choi.jpg";
import patriciy from "../../assets/img/people/Patricia Yu.jpg";
// import loberman from '../../assets/img/people/null';
import ddelgad1 from "../../assets/img/people/Daniela Delgado.png";
import yuxilee from "../../assets/img/people/Yu Xi Lee.jpg";
import ashashki from "../../assets/img/people/Alice Shashkina.jpg";
import alicel from "../../assets/img/people/Alice Lai.jpg";
import emao1 from "../../assets/img/people/Eileen Mao.jpg";
import reshin from "../../assets/img/people/Rachel Shin.jpg";
import asegar from "../../assets/img/people/Andre Segar.jpg";
import ebrunner from "../../assets/img/people/Emily Brunner.jpg";
import aranders from "../../assets/img/people/Anna Anderson.jpg";
import loberman from "../../assets/img/people/Lily Oberman.jpg";
import hsiaotyp from "../../assets/img/people/Hsiao Tyng Peck.jpg";

import bboxer from "../../assets/img/people/Ben Boxer.jpg";
import jhopper from "../../assets/img/people/J.D. Hopper.jpg";
import bpdohert from "../../assets/img/people/Bridget Doherty.jpg";
import younsook from "../../assets/img/people/Kristine Kim.jpg";

/**
 * @brief Pretty self explanatory json formatted data of people. People without
 * headshots are indicated with a null filename.
 */
export const PEOPLE_DATA = {
  scarpent: {
    first_name: "Sebastian",
    last_name: "Carpenter",
    team: "Creative",
    position: "Creative Director",
    filename: "Sebastian Carpenter.jpg",
    image: scarpent,
  },
  wjiao: {
    first_name: "Mimi",
    last_name: "Jiao",
    team: "Creative",
    position: "Creative Director",
    filename: "Weiyin Jiao.jpg",
    image: wjiao,
  },
  szhai: {
    first_name: "Sabrina",
    last_name: "Zhai",
    team: "Creative",
    position: "Head of Web",
    filename: "Sabrina Zhai.jpg",
    image: szhai,
  },
  jsaik: {
    first_name: "Jaclyn",
    last_name: "Saik",
    team: "Creative",
    position: "Web Designer",
    filename: "Jaclyn Saik.jpg",
    image: jsaik,
  },
  jeeyoonk: {
    first_name: "Jenna",
    last_name: "Kim",
    team: "Creative",
    position: "Web Designer",
    filename: "Jeeyoon Kim.jpg",
    image: jeeyoonk,
  },
  sophiaki: {
    first_name: "Sophia",
    last_name: "Kim",
    team: "Creative",
    position: "Web Designer",
    filename: "Sophia Kim.jpg",
    image: sophiaki,
  },
  rickyche: {
    first_name: "Ricky",
    last_name: "Chen",
    team: "Creative",
    position: "Web Designer",
    filename: "Ricky Chen.jpg",
    image: rickyche,
  },
  myou: {
    first_name: "Michael",
    last_name: "You",
    team: "Creative",
    position: "Web Developer",
    filename: "Michael You.jpg",
    image: myou,
  },
  rxun: {
    first_name: "Ruiran",
    last_name: "Xun",
    team: "Creative",
    position: "Web Developer",
    filename: "Ruiran Xun.jpg",
    image: rxun,
  },
  hpnguyen: {
    first_name: "Phi",
    last_name: "Nguyen",
    team: "Creative",
    position: "Web Developer",
    filename: "Henry Nguyen.jpg",
    image: hpnguyen,
  },
  changjuc: {
    first_name: "Danny",
    last_name: "Cho",
    team: "Creative",
    position: "Head of Motion",
    filename: "Chang Jun Cho.jpg",
    image: changjuc,
  },
  flg: {
    first_name: "Franklin",
    last_name: "Guttman",
    team: "Creative",
    position: "Motion Designer",
    filename: null,
  },
  hycai: {
    first_name: "Hannah",
    last_name: "Cai",
    team: "Creative",
    position: "Motion Designer",
    filename: "Hannah Cai.jpg",
    image: hycai,
  },
  sammiek: {
    first_name: "Sammie",
    last_name: "Kim",
    team: "Creative",
    position: "Motion Designer",
    filename: "Sammie Kim.jpg",
    image: sammiek,
  },
  yrt: {
    first_name: "Yoshi",
    last_name: "Torralva",
    team: "Creative",
    position: "Motion Designer",
    filename: "Yoshua Torralva.jpg",
    image: yrt,
  },
  eileenl1: {
    first_name: "Eileen",
    last_name: "Lee",
    team: "Creative",
    position: "Motion Designer",
    filename: null,
  },
  elizabew: {
    first_name: "Elizabeth",
    last_name: "Wang",
    team: "Creative",
    position: "Motion Designer",
    filename: "Elizabeth Wang.jpg",
    image: elizabew,
  },
  ahl2: {
    first_name: "Angela",
    last_name: "Lee",
    team: "Creative",
    position: "Head of Print",
    filename: "Angela Lee.jpg",
    image: ahl2,
  },
  alcai: {
    first_name: "Alice",
    last_name: "Cai",
    team: "Creative",
    position: "Print Designer",
    filename: null,
  },
  ehyang: {
    first_name: "Ethan",
    last_name: "Yang",
    team: "Creative",
    position: "Print Designer",
    filename: null,
  },
  ertsai: {
    first_name: "Elysha",
    last_name: "Tsai",
    team: "Creative",
    position: "Print Designer",
    image: ertsai,
  },
  chsong: {
    first_name: "Caroline",
    last_name: "Song",
    team: "Creative",
    position: "Print Designer",
    filename: "Caroline Song.jpg",
    image: chsong,
  },
  puxins: {
    first_name: "Clytze",
    last_name: "Sun",
    team: "Creative",
    position: "Head of Photo",
    filename: "Clytze Sun.jpg",
    image: puxins,
  },
  ddomalik: {
    first_name: "David",
    last_name: "Domalik",
    team: "Creative",
    position: "Photographer",
    filename: "David Domalik.jpg",
    image: ddomalik,
  },
  mcagan: {
    first_name: "Melissa ",
    last_name: "Cagan",
    team: "Creative",
    position: "Photographer",
    filename: "Melissa Cagan.jpg",
    image: mcagan
  },
  cmay1: {
    first_name: "CJ",
    last_name: "May",
    team: "Creative",
    position: "Photographer",
    filename: "Christopher May.jpg",
    image: cmay1,
  },
  iyip: {
    first_name: "Iris",
    last_name: "Yip",
    team: "Creative",
    position: "Photographer",
    filename: null,
  },
  vderienz: {
    first_name: "Vincent",
    last_name: "DeRienzo",
    team: "Design",
    position: "Head Design Coordinator",
    filename: "Vincent DeRienzo.jpg",
    image: vderienz
  },
  aburbano: {
    first_name: "Ashley",
    last_name: "Burbano",
    team: "Design",
    position: "Design Coordinator",
    filename: null,
  },
  seyoungc: {
    first_name: "Seyoung",
    last_name: "Choo",
    team: "Design",
    position: "Design Coordinator",
    filename: "Seyoung Choo.jpg",
    image: seyoungc
  },
  mpandura: {
    first_name: "Maya",
    last_name: "Pandurangan",
    team: "Design",
    position: "Designer: Obfuscate",
    filename: "Maya Pandurangan.jpg",
    image: mpandura,
  },
  abhartia: {
    first_name: "Aadya ",
    last_name: "Bhartia",
    team: "Design",
    position: "Designer: Renasci",
    filename: "Aadya Bhartia.jpg",
    image: abhartia,
  },
  odh: {
    first_name: "Owen",
    last_name: "Haft",
    team: "Design",
    position: "Designer: Bound",
    filename: "Owen Haft.jpg",
    image: odh,
  },
  carmeny: {
    first_name: "Carmen",
    last_name: "Yu",
    team: "Design",
    position: "Designer: Bound",
    filename: "Carmen Yu.jpg",
    image: carmeny,
  },
  abandi: {
    first_name: "Arushi",
    last_name: "Bandi",
    team: "Design",
    position: "Designer: Obfuscate",
    filename: "Arushi Bandi.jpg",
    image: abandi,
  },
  knandgao: {
    first_name: "Khushi",
    last_name: "Nandgaonkar",
    team: "Design",
    position: "Designer: Mirror",
    filename: "Khushi Nandgaonkar.jpg",
    image: knandgao,
  },
  kathyz: {
    first_name: "Kathy",
    last_name: "Zhang",
    team: "Design",
    position: "Designer: Mirror",
    filename: "Kathy Zhang.jpg",
    image: kathyz,
  },
  skylarm: {
    first_name: "Skylar",
    last_name: "McAuliffe",
    team: "Design",
    position: "Designer: The Marianas Trench",
    filename: "Skylar McAuliffe.jpg",
    image: skylarm
  },
  ajafrani: {
    first_name: "Amal ",
    last_name: "Jafrani",
    team: "Design",
    position: "Designer: Bloom",
    filename: "Amal Jafrani.jpg",
    image: ajafrani,
  },
  jlai2: {
    first_name: "Jessica",
    last_name: "Lai",
    team: "Design",
    position: "Designer: Gossamer Idle",
    filename: "Jessica Lai.jpg",
    image: jlai2,
  },
  ejchapma: {
    first_name: "Elise",
    last_name: "Chapman",
    team: "Design",
    position: "Designer: Gossamer Idle",
    filename: "Elise Chapman.jpg",
    image: ejchapma,
  },
  nwaldram: {
    first_name: "Natalie",
    last_name: "Waldram",
    team: "Design",
    position: "Designer: Bloom",
    filename: "Natalie Waldram.jpg",
    image: nwaldram,
  },
  ihorgan: {
    first_name: "Iz",
    last_name: "Horgan",
    team: "Design",
    position: "Designer: Chrysophyta",
    filename: "Isabel Horgan.jpg",
    image: ihorgan,
  },
  apao: {
    first_name: "Annalisa",
    last_name: "Pao",
    team: "Design",
    position: "Designer: Nexus",
    filename: "Annalisa Pao.jpg",
    image: apao,
  },
  yinjiet: {
    first_name: "Jacky",
    last_name: "Tian",
    team: "Design",
    position: "Designer: Relinquo",
    filename: "Jacky Tian.jpg",
    image: yinjiet,
  },
  minghaoy: {
    first_name: "Kwins",
    last_name: "Yang",
    team: "Design",
    position: "Designer: Relinquo",
    filename: "Minghao Yang.jpg",
    image: minghaoy,
  },
  lkendric: {
    first_name: "Leah",
    last_name: "Kendrick",
    team: "Design",
    position: "Designer: Icarus",
    filename: "Leah Kendrick.jpg",
    image: lkendric,
  },
  hsiaotyp: {
    first_name: "Tyng",
    last_name: "Peck",
    team: "Design",
    position: "Designer: Icarus",
    image: hsiaotyp,
  },
  jwesthei: {
    first_name: "Jessa",
    last_name: "Westheimer",
    team: "Design",
    position: "Designer: Somatic",
    filename: null,
  },
  oluk: {
    first_name: "Olivia",
    last_name: "Luk",
    team: "Design",
    position: "Designer: Invasion",
    filename: "Olivia Luk.jpg",
    image: oluk,
  },
  cscheire: {
    first_name: "Cassie",
    last_name: "Scheirer",
    team: "Design",
    position: "Designer: Digital Warfare",
    filename: "Cassandra Scheirer.jpg",
    image: cscheire
  },
  madelind: {
    first_name: "Madi",
    last_name: "Davis",
    team: "Design",
    position: "Designer: Digital Warfare",
    filename: null,
  },
  adriennw: {
    first_name: "Adrienne",
    last_name: "Wang",
    team: "Model",
    position: "Model",
    filename: "Adrienne Wang.jpg",
    image: adriennw,
  },
  aestuart: {
    first_name: "Audry",
    last_name: "Stuart",
    team: "Model",
    position: "Model",
    filename: "Audry Stuart.jpg",
    image: aestuart,
  },
  csinagra: {
    first_name: "Chloe",
    last_name: "Sinagra",
    team: "Model",
    position: "Model",
    filename: "Chloe Sinagra.jpg",
    image: csinagra,
  },
  christi5: {
    first_name: "Christina",
    last_name: "Li",
    team: "Model",
    position: "Model",
    filename: "Christina Li.jpg",
    image: christi5,
  },
  cmedward: {
    first_name: "Clayton",
    last_name: "Edwards",
    team: "Model",
    position: "Model",
    filename: "Clayton Edwards.jpg",
    image: cmedward,
  },
  dgardilc: {
    first_name: "Danova",
    last_name: "Gardilcic",
    team: "Model",
    position: "Model",
    filename: "Danova Gardilcic.jpg",
    image: dgardilc,
  },
  dongwonl: {
    first_name: "Dong Won (Don)",
    last_name: "Lee",
    team: "Model",
    position: "Model",
    filename: "Dong Won Lee.jpg",
    image: dongwonl,
  },
  fpd: {
    first_name: "Fiona",
    last_name: "Dubrosa",
    team: "Model",
    position: "Model Coordinator",
    filename: "Fiona Dubrosa.jpg",
    image: fpd
  },
  xhe2: {
    first_name: "Ivy",
    last_name: "He",
    team: "Model",
    position: "Model",
    filename: "Xiao He.jpg",
    image: xhe2,
  },
  jlangan: {
    first_name: "Jade",
    last_name: "Langan",
    team: "Model",
    position: "Model",
    filename: "Jade Langan.jpg",
    image: jlangan,
  },
  jtimczyk: {
    first_name: "Jessica",
    last_name: "Timczyk",
    team: "Model",
    position: "Producer, Model",
    filename: "Jessica Timczyk.jpg",
    image: jtimczyk,
  },
  minjael2: {
    first_name: "Julia",
    last_name: "Lee",
    team: "Model",
    position: "Model",
    filename: "Min Jae Lee.jpg",
    image: minjael2,
  },
  kbalenza: {
    first_name: "Kyra",
    last_name: "Balenzano",
    team: "Model",
    position: "Model",
    filename: "Kyra Balenzano.jpg", 
    image: kbalenza,
  },
  lgunasek: {
    first_name: "Lahiru",
    last_name: "Gunasekara",
    team: "Model",
    position: "Model",
    filename: "Lahiru Gunasekara.jpg",
    image: lgunasek,
  },
  mcornwal: {
    first_name: "Lindy",
    last_name: "Cornwall",
    team: "Model",
    position: "Model",
    filename: "Melinda Cornwall.jpg",
    image: mcornwal,
  },
  laltus: {
    first_name: "Lucy",
    last_name: "Altus",
    team: "Model",
    position: "Model",
    filename: "Lucy Altus.jpg",
    image: laltus,
  },
  mgamerma: {
    first_name: "Max",
    last_name: "Gamerman",
    team: "Model",
    position: "Model Coordinator",
    filename: "Max Gamerman.jpg",
    image: mgamerma,
  },
  maxliu: {
    first_name: "Max",
    last_name: "Liu",
    team: "Model",
    position: "Model",
    filename: "Max Liu.jpg",
    image: maxliu,
  },
  ruomingx: {
    first_name: "Ming",
    last_name: "Xin",
    team: "Model",
    position: "Model",
    filename: "Ruoming Xin.jpg",
    image: ruomingx,
  },
  makim: {
    first_name: "Minseo (Angelica)",
    last_name: "Kim",
    team: "Model",
    position: "Model",
    filename: null,
  },
  morganbo: {
    first_name: "Morgan",
    last_name: "Boyd",
    team: "Model",
    position: "Model",
    filename: "Morgan Boyd.jpg",
    image: morganbo
  },
  njeans: {
    first_name: "Nathalie",
    last_name: "Jeans",
    team: "Model",
    position: "Model",
    filename: "Nathalie Jeans.jpg",
    image: njeans,
  },
  nathanwa: {
    first_name: "Nathan",
    last_name: "Wai",
    team: "Model",
    position: "Model",
    filename: "Nathan Wai.jpg",
    image: nathanwa,
  },
  nwai: {
    first_name: "Nora",
    last_name: "Wai",
    team: "Model",
    position: "Model",
    filename: "Nora Wai.jpg",
    image: nwai,
  },
  ojinsi: {
    first_name: "Omisa",
    last_name: "Jinsi",
    team: "Model",
    position: "Model",
    filename: "Omisa Jinsi.jpg",
    image: ojinsi,
  },
  pgao1: {
    first_name: "Patrick",
    last_name: "Gao",
    team: "Model",
    position: "Model",
    image: null,
  },
  pqin: {
    first_name: "Pauline",
    last_name: "Qin",
    team: "Model",
    position: "Head Model Coordinator",
    filename: "Pauline Qin.jpg",
    image: pqin,
  },
  rkoanda: {
    first_name: "Rahjshiba",
    last_name: "Koanda",
    team: "Model",
    position: "Model",
    filename: null,
  },
  radeoti: {
    first_name: "Remi",
    last_name: "Adeoti",
    team: "Model",
    position: "Model Coordinator",
    image: radeoti,
  },
  sammiep: {
    first_name: "Sammie",
    last_name: "Paul",
    team: "Model",
    position: "Model",
    image: null,
  },
  sophiale: {
    first_name: "Sophia",
    last_name: "Lee",
    team: "Model",
    position: "Model",
    image: null,
  },
  tbournia: {
    first_name: "Themistokles",
    last_name: "Bournias",
    team: "Model",
    position: "Model",
    filename: "Themistokles Bournias.jpg",
    image: tbournia,
  },
  thk1: {
    first_name: "Tiffany ",
    last_name: "Kim",
    team: "Model",
    position: "Model",
    filename: "Tiffany Kim.jpg",
    image: thk1,
  },
  mkimkim: {
    first_name: "Aris",
    last_name: "Kim",
    team: "Public Relations",
    position: "Head of PR",
    filename: "Min Ji Kim Kim.jpg",
    image: mkimkim,
  },
  lannal: {
    first_name: "Lanna",
    last_name: "Lang",
    team: "Public Relations",
    position: "Social Media Manager",
    filename: "Lanna Lang.jpg",
    image: lannal,
  },
  sspektor: {
    first_name: "Sabina",
    last_name: "Spektor",
    team: "Public Relations",
    position: "Sponsorship Liaison",
    filename: "Sabina Spektor.jpg",
    image: sspektor,
  },
  ejc2: {
    first_name: "Elizabeth",
    last_name: "Choi",
    team: "Public Relations",
    position: "Sponsorship Liaison",
    filename: "Elizabeth Choi.jpg",
    image: ejc2,
  },
  patriciy: {
    first_name: "Patricia",
    last_name: "Yu",
    team: "Design",
    position: "Designer: Salvos",
    filename: "Patricia Yu.jpg",
    image: patriciy,
  },
  loberman: {
    first_name: "Lily",
    last_name: "Oberman",
    team: "Design",
    position: "Designer: The Marianas Trench",
    filename: "Lily Oberman.jpg",
    image: loberman,
  },
  ddelgad1: {
    first_name: "Daniela",
    last_name: "Delgado",
    team: "Producers",
    position: "Former Producer & Contributor",
    image: ddelgad1,
  },
  yuxilee: {
    first_name: "Yu Xi",
    last_name: "Lee",
    team: "Entertainment",
    position: "Head of Entertainment",
    image: yuxilee,
  },
  ashashki: {
    first_name: "Alice",
    last_name: "Shashkina",
    team: "Entertainment",
    position: "Head of Entertainment",
    image: ashashki,
  },
  ameliac: {
    first_name: "Amelia",
    last_name: "Chan",
    team: "Entertainment",
    position: "Dancer",
    image: null,
  },
  cdi: {
    first_name: "Christina",
    last_name: "Di",
    team: "Entertainment",
    position: "Dancer",
    image: null,
  },
  xinyihu: {
    first_name: "Cynthia",
    last_name: "Hu",
    team: "Entertainment",
    position: "Dancer",
    image: null,
  },
  vjung: {
    first_name: "Victoria",
    last_name: "Jung",
    team: "Entertainment",
    position: "Dancer",
    image: null,
  },
  alicel: {
    first_name: "Alice",
    last_name: "Lai",
    team: "Entertainment",
    position: "Dancer",
    image: alicel,
  },
  emao1: {
    first_name: "Eileen",
    last_name: "Mao",
    team: "Entertainment",
    position: "Dancer",
    image: emao1,
  },
  reshin: {
    first_name: "Rachel",
    last_name: "Shin",
    team: "Entertainment",
    position: "Dancer",
    image: reshin,
  },
  asegar: {
    first_name: "Andre",
    last_name: "Segar",
    team: "Production",
    position: "Head Of Production",
    image: asegar,
  },
  ebrunner: {
    first_name: "Emily",
    last_name: "Brunner",
    team: "Production",
    position: "Lead Sound Designer",
    image: ebrunner,
  },
  bboxer: {
    first_name: "Benjamin",
    last_name: "Boxer",
    team: "Cinematography",
    position: "Head of Cinematography",
    image: bboxer,
  },
  jhopper: {
    first_name: "JD",
    last_name: "Hopper",
    team: "Cinematography",
    position: "Cinematographer",
    image: jhopper,
  },
  bpdohert: {
    first_name: "Bridget",
    last_name: "Doherty",
    team: "Cinematography",
    position: "Editor",
    image: bpdohert,
  },
  younsook: {
    first_name: "Kristine",
    last_name: "Kim",
    team: "Cinematography",
    position: "Editor",
    image: younsook,
  },
  rnymeyer: {
    first_name: "Reiley",
    last_name: "Nymeyer",
    team: "Production",
    position: "Assist Lighting Designer",
    image: null,
  },
  bsforza: {
    first_name: "Bianca",
    last_name: "Sforza",
    team: "Production",
    position: "Assist Lighting Designer",
    image: null,
  },
  oadisa: {
    first_name: "Tobi",
    last_name: "Adisa",
    team: "Production",
    position: "Composer",
    image: null,
  },
  jbrauch: {
    first_name: "Joe",
    last_name: "Brauch",
    team: "Production",
    position: "Composer",
    image: null,
  },
  iegawa: {
    first_name: "Isabella",
    last_name: "Egawa",
    team: "Production",
    position: "Composer",
    image: null,
  },
  sebastig: {
    first_name: "Sebastian",
    last_name: "Gutierrez",
    team: "Production",
    position: "Composer",
    image: null,
  },
  jhandelm: {
    first_name: "Josiah",
    last_name: "Handelman",
    team: "Production",
    position: "Composer",
    image: null,
  },
  rslewis: {
    first_name: "Robb",
    last_name: "Lewis",
    team: "Production",
    position: "Composer",
    image: null,
  },
  tmims: {
    first_name: "Terrence",
    last_name: "Mims",
    team: "Production",
    position: "Composer",
    image: null,
  },
  shambhav: {
    first_name: "Shambhavi",
    last_name: "Mishra",
    team: "Production",
    position: "Composer",
    image: null,
  },
  wrinkoff: {
    first_name: "Will",
    last_name: "Rinkoff",
    team: "Production",
    position: "Composer",
    image: null,
  },
  lasherma: {
    first_name: "Lucas",
    last_name: "Sherman",
    team: "Production",
    position: "Composer",
    image: null,
  },
  kwalsh: {
    first_name: "Kieran",
    last_name: "Walsh",
    team: "Production",
    position: "Composer",
    image: null,
  },
  traviswr: {
    first_name: "Travis",
    last_name: "Wright",
    team: "Production",
    position: "Composer",
    image: null,
  },
  mzwiebel: {
    first_name: "Matthew",
    last_name: "Zwiebel",
    team: "Production",
    position: "Composer",
    image: null,
  },
  aranders: {
    first_name: "Anna",
    last_name: "Anderson",
    team: "Public Relations",
    position: "Copywriter",
    image: aranders,
  },
  annien: {
    first_name: "Annie",
    last_name: "Nguyen",
    team: "Production",
    position: "Assist Sound Designer",
    image: null,
  },
  jhelms: {
    first_name: "Tucker",
    last_name: "Helms",
    team: "Production",
    position: "Composer",
    image: null,
  },
};

/**
 * @brief Contains Andrew IDs sorted by their teams.
 *
 * Names appear in the order that is defined below, so you can change the order
 * here.
 */
export const PEOPLE_BY_TEAMS = {
  Producers: [
    "ddelgad1",
    "jtimczyk",
  ],
  Design: [
    "vderienz",
    "aburbano",
    "seyoungc",
    "ajafrani",
    "nwaldram",
    "odh",
    "carmeny",
    "ihorgan",
    "madelind",
    "cscheire",
    "patriciy",
    "ejchapma",
    "jlai2",
    "lkendric",
    "hsiaotyp",
    "oluk",
    "knandgao",
    "kathyz",
    "apao",
    "abandi",
    "mpandura",
    "yinjiet",
    "minghaoy",
    "abhartia",
    "jwesthei",
    "skylarm",
    "loberman",
  ],
  Model: [
    "pqin",
    "radeoti",
    "fpd",
    "mgamerma",
    "laltus",
    "kbalenza",
    "tbournia",
    "morganbo",
    "mcornwal",
    "cmedward",
    "pgao1",
    "dgardilc",
    "lgunasek",
    "xhe2",
    "njeans",
    "ojinsi",
    "thk1",
    "makim",
    "rkoanda",
    "jlangan",
    "dongwonl",
    "minjael2",
    "sophiale",
    "christi5",
    "maxliu",
    "sammiep",
    "csinagra",
    "aestuart",
    "nathanwa",
    "nwai",
    "adriennw",
    "ruomingx",
  ],
  Entertainment: [
    "yuxilee",
    "ashashki",
    "ameliac",
    "cdi",
    "xinyihu",
    "vjung",
    "alicel",
    "emao1",
    "reshin",
  ],
  Production: [
    "asegar",
    "ebrunner",
    "annien",
    "rnymeyer",
    "bsforza",
    "oadisa",
    "jbrauch",
    "iegawa",
    "sebastig",
    "jhandelm",
    "rslewis",
    "tmims",
    "shambhav",
    "wrinkoff",
    "lasherma",
    "kwalsh",
    "traviswr",
    "mzwiebel",
    "jhelms",
  ],
  Creative: [
    "scarpent",
    "wjiao",
    "changjuc",
    "puxins",
    "ahl2",
    "szhai",
    "hycai",
    "flg",
    "sammiek",
    "eileenl1",
    "yrt",
    "elizabew",
    "mcagan",
    "ddomalik",
    "cmay1",
    "iyip",
    "alcai",
    "chsong",
    "ertsai",
    "ehyang",
    "rickyche",
    "jeeyoonk",
    "sophiaki",
    "jsaik",
    "hpnguyen",
    "rxun",
    "myou",
  ],
  "Public Relations": [
    "mkimkim",
    "lannal",
    "ejc2",
    "sspektor",
    "aranders",
  ],
  Cinematography: [
    "bboxer",
    "jhopper",
    "bpdohert",
    "younsook",
  ],
};

function shuffle(a) {
	for (let i = a.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
}

export function getRandomHeadshots(num) {
  var output = []
  var keys = shuffle(Object.keys(PEOPLE_DATA));
  var i = 0

  while (output.length < num) {
    if (PEOPLE_DATA[keys[i]]['image']) {
      output.push(PEOPLE_DATA[keys[i]]['image']);
    }
    i += 1;
  }
  return output;
}